import React, { useContext, useMemo, useRef, useState } from 'react';
import { TargetingButton } from '@/features/editor/widgets/shared/targeting-controls/targeting-button';
import { PriceTestAudienceModal } from '@/features/editor/widgets/price-test/audience-modal';
import { EditorContext } from '@/features/editor/context/editor-context';
import { AccountContext } from '@/features/account-context';

export function PriceTestAudienceButton() {
  const ref = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  const {
    account: {
      store: { currency: defaultCurrency },
    },
  } = useContext(AccountContext);

  const {
    experienceState: { currentExperience, setTargetingAudience },
  } = useContext(EditorContext);

  const targeting = useMemo(
    () => currentExperience?.targeting?.other,
    [currentExperience?.targeting?.other, setTargetingAudience],
  );

  const onClick = () => {
    setIsVisible(true);
  };

  const subtitle = useMemo(() => {
    if (!targeting) {
      return `${defaultCurrency}`;
    }
    const currency = targeting?.find(
      (prop) => prop.qbProps?.caption === `Cart Currency`,
    );
    const hasMore = targeting?.length > 1;
    return `${currency?.values?.[0]?.value}${
      hasMore ? ` & ${targeting.length - 1} More` : ``
    }`;
  }, [targeting]);

  return (
    <>
      <PriceTestAudienceModal
        fromRef={ref}
        isVisible={isVisible}
        setIsVisible={setIsVisible}
      />
      <TargetingButton
        wrapperRef={ref}
        title="Audience"
        subtitle={subtitle}
        onClick={onClick}
      />
    </>
  );
}
